<template>
  <footer>
    <div class="main_footer">
      <div class="container">
        <div class="container">
          <article class="row">
            <aside class="col-md-3">
              <div class="footer_logo">
                <img src="../assets/images/logo.png" alt="" />
                <ul>
                  <li>
                    <a href="https://twitter.com/stable_switch" target="_blank"
                      ><i class="fab fa-twitter"></i
                    ></a>
                  </li>
                  <li>
                    <a href="https://t.me/joinchat/qgSp8gR-tvY5OGZk" target="_blank"
                      ><i class="fab fa-telegram"></i
                    ></a>
                  </li>
                  <li>
                    <a href="https://www.youtube.com/channel/UCaCvC3y1EkdyrQFl-suL3fg" target="_blank"
                      ><i class="fab fa-youtube"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </aside>
            <aside class="col-md-3">
              <div class="footer_link">
                <h4>Quick Links</h4>
                <ul>
                  <!-- <li><router-link to="/">Lending</router-link></li> -->
                  <!-- <li><router-link to="affiliate">Affiliates</router-link></li> -->
                  <li>
                    <router-link to="how-it-works">How it Works</router-link>
                  </li>
                  <li><router-link to="contact">Contact</router-link></li>
                  <li><router-link to="faq">Faq's</router-link></li>
                  <!-- <li><router-link to="deposite">Deposite</router-link></li> -->
                </ul>
              </div>
            </aside>
            <aside class="col-md-3">
              <div class="footer_link">
                <h4>Quick Links</h4>
                <ul>

                  <li><router-link to="terms-conditions">Privacy Policy </router-link></li>
                  <!-- <li><a href="#">Terms & Condition</a></li> -->
                  <!-- <li><a href="#">Disclaimer </a></li> -->
                  <li><router-link to="liquidity">Liquidity </router-link></li>
                </ul>
              </div>
            </aside>
          </article>
        </div>
      </div>
    </div>
    <div class="copyright">
      <div class="container">
        <p>Copyright © All Right Reserved</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style scoped>
</style>
